(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Temoignages_Clients"] && !Shopify.designMode) return;
  try {
    
class TestimonialsCarousel {
  constructor() {
    this.track = document.querySelector('.testimonials-track');
    this.wrapper = document.querySelector('.testimonials-wrapper');
    this.items = document.querySelectorAll('.testimonial-item');
    this.prevButton = document.querySelector('.carousel-control.prev');
    this.nextButton = document.querySelector('.carousel-control.next');
    this.dots = document.querySelectorAll('.carousel-dot');
    
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.isScrolling = false;
    this.isSwiping = false;
    
    // Calculer les dimensions une seule fois à l'initialisation
    this.slideWidth = 0;
    this.gap = 16; // 1rem gap
    
    this.init();
  }
  
  init() {
    if (window.innerWidth >= 768) return;
    
    // Attendre que les images soient chargées pour calculer les dimensions correctes
    if (document.readyState === 'complete') {
      this.calculateDimensions();
    } else {
      window.addEventListener('load', () => this.calculateDimensions());
    }
    
    this.updateButtons();
    this.bindEvents();
    this.updateSlidePosition();
  }
  
  bindEvents() {
    this.prevButton.addEventListener('click', () => this.prev());
    this.nextButton.addEventListener('click', () => this.next());
    
    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index);
        this.goToSlide(index);
      });
    });
    
    // Touch events avec gestion améliorée
    this.track.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: false });
    this.track.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
    this.track.addEventListener('touchend', (e) => this.handleTouchEnd(e));
  }
    calculateDimensions() {
    const firstSlide = this.items[0];
    this.slideWidth = firstSlide.offsetWidth;
    
    // S'assurer que la première slide est bien positionnée
    this.updateSlidePosition();
  }
  
  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchStartY = e.touches[0].clientY;
    this.isScrolling = undefined;
    this.isSwiping = true;
    
    this.wrapper.classList.add('is-swiping');
  }
  
  handleTouchMove(e) {
    if (!this.isSwiping) return;
    
    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;
    const deltaX = this.touchStartX - touchX;
    const deltaY = this.touchStartY - touchY;
    
    if (this.isScrolling === undefined) {
      this.isScrolling = Math.abs(deltaY) > Math.abs(deltaX);
    }
    
    if (this.isScrolling) {
      this.isSwiping = false;
      this.wrapper.classList.remove('is-swiping');
      return;
    }
    
    e.preventDefault();
    
    // Calculer la nouvelle position avec limites
    const currentOffset = this.currentIndex === 0 ? 0 : -(this.currentIndex * (this.slideWidth + this.gap));
    const newOffset = currentOffset - deltaX;
    const maxOffset = -((this.items.length - 1) * (this.slideWidth + this.gap));
    
    // Appliquer la transformation avec limites et effet de résistance
    if (newOffset > 0) {
      // Effet de résistance au début
      this.track.style.transform = `translateX(${newOffset * 0.3}px)`;
    } else if (newOffset < maxOffset) {
      // Effet de résistance à la fin
      const overscroll = maxOffset - newOffset;
      this.track.style.transform = `translateX(${maxOffset - (overscroll * 0.3)}px)`;
    } else {
      // Position normale
      this.track.style.transform = `translateX(${newOffset}px)`;
    }
  }
  
  handleTouchEnd(e) {
    if (!this.isSwiping) return;
    
    this.isSwiping = false;
    this.wrapper.classList.remove('is-swiping');
    
    const touchEndX = e.changedTouches[0].clientX;
    const deltaX = this.touchStartX - touchEndX;
    const minSwipeDistance = 50;
    
    if (Math.abs(deltaX) < minSwipeDistance) {
      // Retour à la position initiale si le swipe n'est pas assez long
      this.updateSlidePosition();
      return;
    }
    
    if (deltaX > 0 && this.currentIndex < this.items.length - 1) {
      this.next();
    } else if (deltaX < 0 && this.currentIndex > 0) {
      this.prev();
    } else {
      // Retour à la position initiale si on est aux extrémités
      this.updateSlidePosition();
    }
  }
  
  updateSlidePosition() {
    if (window.innerWidth >= 768) return;
    
    const slideWidth = this.items[0].offsetWidth;
    const gap = this.gap;
    
    // Calculer l'offset pour chaque position
    let offset;
    if (this.currentIndex === 0) {
      // Première slide : pas d'offset négatif
      offset = 0;
    } else {
      // Autres slides : tenir compte de la largeur et du gap
      offset = this.currentIndex * (slideWidth + gap);
    }
    
    this.track.style.transform = `translateX(-${offset}px)`;
  }
  
  updateButtons() {
    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = this.currentIndex === this.items.length - 1;
    
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlidePosition();
      this.updateButtons();
    }
  }
  
  next() {
    if (this.currentIndex < this.items.length - 1) {
      this.currentIndex++;
      this.updateSlidePosition();
      this.updateButtons();
    }
  }
  
  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlidePosition();
    this.updateButtons();
  }
}

// Initialize carousel
document.addEventListener('DOMContentLoaded', () => {
  new TestimonialsCarousel();
});

// Handle resize avec recalcul des dimensions
let timeout;
window.addEventListener('resize', () => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    const carousel = new TestimonialsCarousel();
  }, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
